// Events used in the Shopify Theme Editor
// Read more: https://shopify.dev/docs/storefronts/themes/architecture/sections/integrate-sections-with-the-theme-editor

export const EDITOR_EVENTS = {
  SECTION_LOAD: "shopify:section:load",
  SECTION_UNLOAD: "shopify:section:unload",
  SECTION_REORDER: "shopify:section:reorder",
  SECTION_SELECT: "shopify:section:select",
  SECTION_DESELECT: "shopify:section:deselect",
  BLOCK_LOAD: "shopify:block:load",
  BLOCK_UNLOAD: "shopify:block:unload",
  BLOCK_REORDER: "shopify:block:reorder",
  BLOCK_SELECT: "shopify:block:select",
  BLOCK_DESELECT: "shopify:block:deselect",
  INSPECTOR_ACTIVATE: "shopify:inspector:activate",
  INSPECTOR_DEACTIVATE: "shopify:inspector:deactivate",
} as const;

/**
 * CUSTOM EVENTS
 */

// Events used in manipulating the customer cart
export const CART_EVENTS = {
  ADD: "cart:add",
  UPDATE: "cart:update",
  REMOVE: "cart:remove",
  CLEAR: "cart:clear",
  OPEN: "cart:open",
  CLOSE: "cart:close",
  ADDED: "cart:added",
  MODIFIED: "cart:modified",
  FETCHED: "cart:fetched",
  ADD_GIFT_CARD: "cart:add:gift_card",
  ADD_LOOK_ITEM: "cart:add:look_item",
  ADD_LOOK_ITEMS: "cart:add:look_items",
  SELECT_VARIANT: "cart:selected_variant",
} as const;

// Events used in manipulating modals remotely
export const MODAL_EVENTS = {
  OPEN: "modal:open",
  CLOSE: "modal:close",
};

// Events used in manipulating customer data
export const CUSTOMER_EVENTS = {
  DELETE: "customer:delete",
  RECOVER: "customer:recover",
  UPDATE_DETAILS: "customer:update:details",
  UPDATE_LOGIN: "customer:update:login",
  UPDATE_PREFERENCES: "customer:update:preferences",
  GIFT_CARD_BALANCE: "customer:gift-card-balance",
};

export const KLAVIYO_EVENTS = {
  ALERT: "klaviyo:alert",
};

export const GLOBAL_EVENTS = {
  ALERT: "global:alert",
};

export function isCustomEvent(event: Event): event is CustomEvent {
  return "detail" in event;
}

export const POPOVER_EVENTS = {
  DISMISS: "popover:dismiss",
  EVENT: "popover:event",
};

export const PROMOTION_EVENTS = {
  VIEW: "promotion:view",
  SELECT: "promotion:select",
} as const;

export const CAROUSEL_EVENTS = {
  VIEW_ITEM: "carousel:view_item",
} as const;

export const INTERACTION_EVENTS = {
  INTERACTION_IMPRESSION: "interaction:impression",
  INTERACTION_SELECT: "interaction:select",
} as const;

export const INTERACTION_TYPES = {
  IMPRESSION: "impression",
  SELECT: "select",
  ADD_TO_CART: "add to cart",
} as const;

export const COLLECTION_EVENTS = {
  COLLECTION_VIEW_LIST: "collection:view_list",
} as const;

export const ACCOUNT_EVENTS = {
  ACCOUNT_NAVIGATION: "account:navigation",
};

export const SHOPIFY_EVENTS = {
  QUICK_SEARCH: "shopify:quick-search",
};

export const PRODUCT_EVENTS = {
  SELECT_ITEM: "product:select_item",
};

export const GOOGLE_ANALYTIC_EVENTS = {
  REMOVE_FROM_CART: "remove_from_cart",
  ADD_TO_CART: "add_to_cart",
  SELECT_ITEM: "select_item",
  SELECT_PROMOTION: "select_promotion",
  VIEW_PROMOTION: "view_promotion",
  VIEW_CART: "view_cart",
  VIEW_ITEM: "view_item",
  VIEW_ITEM_LIST: "view_item_list",
  JOIN_MODAL: "joinModal",
  SIGN_IN_MODAL: "signInModal",
  SIGN_IN_PROMPT: "signInPrompt",
  VIEW_SEARCH_RESULTS: "view_search_results",
  ["404_ERROR"]: "404_error",
  PAGE_VIEW: "pageView",
  MEMBER_LOGIN: "memberLogin",
  CREATE_ACCOUNT_SUCCESS: "createaccountSuccess",
  CALL_TO_ACTION: "callToAction",
  PAGE_LOAD_HASHED_EMAIL: "pageLoadHashedEmail",
  DYNAMIC_REMARKETING: "dynamicRemarketing",
  INTERACTION_EVENT_IMPRESSION: "interaction-event-impression",
  INTERACTION_EVENT_CLICK: "interaction-event-click",
} as const;
